"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopifyNext = void 0;
require("url-search-params-polyfill");
var context_1 = require("./context");
var bootstrap_1 = require("./bootstrap");
var helpers_1 = require("./helpers");
var Components = require("./components");
var Utils = require("./utils");
var ShopifyNext = /** @class */ (function () {
    function ShopifyNext(options) {
        this.options = options;
        ShopifyNext.Notifications.set(options.notifications);
    }
    ShopifyNext.prototype.element = function (data) {
        return bootstrap_1.Bootstrap.element(this.options.templates, this.options.sections, data || this.parse());
    };
    ShopifyNext.prototype.bootstrap = function (element, window) {
        var parsedData = this.parse();
        if (window.location.href.includes("localhost"))
            console.log(parsedData);
        var view = new URLSearchParams(window.location.href.split("?")[1]).get("view");
        if (view)
            parsedData.template.suffix = view;
        return bootstrap_1.Bootstrap.bootstrap(element, this.options.templates, this.options.sections, parsedData);
    };
    ShopifyNext.prototype.parse = function () {
        return __assign(__assign({}, this.parseShopifyData()), this.parseShopifySections());
    };
    ShopifyNext.prototype.parseShopifyData = function () {
        var scriptTags = document.querySelectorAll("[data-shopify=data]");
        var searchParamView = new URLSearchParams(window.location.href.split("?")[1]).get("view");
        var data = Object.values(scriptTags).reduce(function (result, scriptTag) {
            var _a, _b, _c;
            var scriptProperty = scriptTag.getAttribute("data-property");
            var scriptData = validateJSON(scriptTag.innerHTML);
            function validateJSON(json) {
                var scriptData = {};
                try {
                    scriptData = JSON.parse(json);
                }
                catch (error) {
                    console.log(error), console.log(json);
                }
                return scriptData;
            }
            var objectKey = scriptProperty.includes(".")
                ? scriptProperty.split(".")[1]
                : scriptProperty;
            var objectType = scriptProperty.includes(".")
                ? scriptProperty.split(".")[0]
                : false;
            return !objectType
                ? __assign(__assign({}, result), (_a = {}, _a[scriptProperty] = scriptData, _a)) : __assign(__assign({}, result), (_b = {}, _b[objectType] = __assign(__assign({}, result[objectType]), (_c = {}, _c[objectKey] = scriptData, _c)), _b));
        }, {});
        if (searchParamView)
            data.template.suffix = searchParamView;
        return data;
    };
    ShopifyNext.prototype.parseShopifySections = function () {
        var scriptTags = document.querySelectorAll("[data-shopify=section]");
        var staticSections = Object.values(scriptTags).reduce(function (result, scriptTag) {
            var _a;
            var scriptProperty = scriptTag.getAttribute("data-property");
            var scriptData = validateJSON(scriptTag.innerHTML);
            function validateJSON(json) {
                var scriptData = {};
                try {
                    scriptData = JSON.parse(json);
                }
                catch (error) {
                    console.log(error), console.log(json);
                }
                return scriptData;
            }
            return scriptData.type == "static"
                ? __assign(__assign({}, result), (_a = {}, _a[scriptProperty] = scriptData, _a)) : result;
        }, {});
        var dynamicSections = Object.values(scriptTags).reduce(function (result, scriptTag) {
            var scriptData = validateJSON(scriptTag.innerHTML);
            function validateJSON(json) {
                var scriptData = {};
                try {
                    scriptData = JSON.parse(json);
                }
                catch (error) {
                    console.log(error), console.log(json);
                }
                return scriptData;
            }
            return scriptData.type == "dynamic" ? __spreadArrays(result, [scriptData]) : result;
        }, []);
        return {
            section: staticSections,
            sections: dynamicSections
        };
    };
    ShopifyNext.Context = context_1.ThemeContext;
    ShopifyNext.Components = Components;
    ShopifyNext.Utils = Utils;
    ShopifyNext.Cart = new helpers_1.Cart();
    ShopifyNext.Wishlist = new helpers_1.Wishlist();
    ShopifyNext.Notifications = new helpers_1.Notifications();
    ShopifyNext.Helpers = new helpers_1.Helpers();
    return ShopifyNext;
}());
exports.ShopifyNext = ShopifyNext;
//# sourceMappingURL=shopify-next.js.map